<template>
    <div class="">
        <div class="flex justify-between">
            <div class="md:w-[90%]">
                <ProductFilterChips />
            </div>
            <!-- Dropdown for select page -->
            <div class="flex items-start justify-end" v-if="!loading">
                <div class="flex whitespace-nowrap items-center gap-2">
                    <select id="global-catalog-select-page" class="bg-[#fff] h-8 pl-1 pr-4 text-[#171717]" v-model="currentPage" @change="getProducts">
                        <option :value="page" v-for="page in totalPages">{{page}}</option>
                    </select> 
                    <span class="text-[#464646]">{{ t('catalog.of') }} {{ totalPages }}</span>
                </div>
            </div>
        </div>

        <Loader v-if="loading" :title="t('globalCatalog.shoppingCart.loading')" />
        <div class="flex flex-col my-3 gap-3" v-else>
            <ProductCard
            v-for="(product, index) in products.products"
            :key="`${branchCode}-${product.productId}`"
            :product="product"
            :index="index"
            />
        </div>
        <div class="flex items-start justify-end" v-if="!loading">
            <div class="flex whitespace-nowrap items-center gap-2">
                <select id="global-catalog-select-page" class="bg-[#fff] h-8 pl-1 pr-4 text-[#171717]" v-model="currentPage" @change="getProducts">
                    <option :value="page" v-for="page in totalPages">{{page}}</option>
                </select> 
                <span class="text-[#464646]">{{ t('catalog.of') }} {{ totalPages }}</span>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed, ref } from 'vue';
import { useGlobalCatalogStore } from "@/stores/globalCatalogStore"
import ProductCard from '@/components/GlobalCatalog/Products/ProductCard.vue';
import ProductFilterChips from '@/components/GlobalCatalog/Products/ProductFilterChips.vue';
import Loader from "@/components/atoms/Loader.vue";
import { useI18n } from 'vue-i18n'
import { getLanguage } from '@/utilities/cookies';

const { t, locale } = useI18n()
locale.value = getLanguage();

const globalCatalogStore = useGlobalCatalogStore()
const currentPage = ref(1);
const branchCode = computed(() => globalCatalogStore.selectedBranch?.BranchCode ?? '');

const getProducts = () => {
    globalCatalogStore.loadProducts(currentPage.value)
}
const products = computed(() => globalCatalogStore.products);
const loading = computed(() => globalCatalogStore.loading);
const totalPages = computed(() => Math.ceil(products.value.productCount / globalCatalogStore.productsPerPage) || 1);
</script>